import { Layout } from "@/components/Layout";
import { About } from "@/components/About";
import { AreasOfAction } from "@/components/AreasOfAction";
import { SullaStampa } from "@/components/SullaStampa";
import { Link } from "react-router-dom";
import { FileText, Download, Scale, HeartHandshake, ArrowRight } from "lucide-react";

export default function ChiSiamoPage() {
  return (
    <Layout>
      <About />

      {/* Resoconto giornata 11 luglio */}
      <section data-testid="chi-siamo-intervento" className="bg-[#1f2d22] text-white py-14 sm:py-20">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-5">
            <HeartHandshake className="w-3.5 h-3.5 text-[#E8C9A0]" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
              La nostra prima azione sul campo
            </span>
          </div>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black leading-tight">
            11 luglio 2026: <span className="italic font-light text-[#E8C9A0]">dalle parole ai fatti.</span>
          </h2>
          <div className="mt-5 space-y-4 text-white/80 leading-relaxed text-sm sm:text-base max-w-3xl">
            <p>
              All'alba di sabato 11 luglio 2026 abbiamo dato vita al primo grande intervento di
              volontariato dell'associazione. Decine di mani si sono unite per aiutare due proprietà di
              Asciano colpite dall'incendio del Monte Faeta: abbiamo rimosso alberi caduti e materiale
              bruciato, ripulito le aree danneggiate e sostenuto concretamente le famiglie coinvolte.
            </p>
            <p>
              È stata la dimostrazione più bella di cosa significhi <strong className="text-white">Per Asciano</strong>:
              cittadini che si prendono cura del proprio territorio, insieme. Un inizio, non un traguardo.
            </p>
          </div>
          <Link
            to="/eventi#intervento-11-luglio"
            data-testid="chi-siamo-intervento-link"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#C15C3D] hover:bg-[#a94c30] text-white font-bold px-6 py-3.5 transition-colors"
          >
            Guarda foto e video della giornata
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      {/* Statuto highlight */}
      <section data-testid="chi-siamo-statuto" className="bg-[#FBF9F6] py-14 sm:py-16 border-y border-[#E5E1D8]">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="bg-white border-2 border-[#1A1A1A] rounded-3xl p-7 sm:p-10 shadow-[0_10px_30px_rgba(0,0,0,0.06)]">
            <div className="flex flex-col sm:flex-row sm:items-center gap-6">
              <div className="w-16 h-16 rounded-2xl bg-[#1A1A1A] text-white flex items-center justify-center shrink-0">
                <Scale className="w-8 h-8" />
              </div>
              <div className="flex-1">
                <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#C15C3D] mb-2">
                  Documento ufficiale
                </div>
                <h3 className="font-display text-2xl sm:text-3xl font-black text-[#1A1A1A] leading-tight">
                  Lo Statuto dell'Associazione
                </h3>
                <p className="mt-3 text-sm sm:text-base text-[#5C5C5C] leading-relaxed">
                  Il documento ufficiale che disciplina la vita, le finalità e il funzionamento di
                  Per Asciano. Pubblicato in piena trasparenza verso cittadini e soci.
                </p>
              </div>
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/documenti/statuto-per-asciano.pdf"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="chi-siamo-statuto-view"
                className="inline-flex items-center gap-2 rounded-full bg-[#1A1A1A] hover:bg-[#2E4F3B] text-white font-semibold text-sm px-5 py-3 transition-colors"
              >
                <FileText className="w-4 h-4" />
                Apri lo Statuto (PDF)
              </a>
              <a
                href="/documenti/statuto-per-asciano.pdf"
                download
                data-testid="chi-siamo-statuto-download"
                className="inline-flex items-center gap-2 rounded-full bg-white border-2 border-[#E5E1D8] hover:border-[#1A1A1A] text-[#1A1A1A] font-semibold text-sm px-5 py-3 transition-colors"
              >
                <Download className="w-4 h-4" />
                Scarica
              </a>
              <Link
                to="/trasparenza"
                data-testid="chi-siamo-trasparenza"
                className="inline-flex items-center gap-2 rounded-full bg-transparent text-[#1A1A1A] hover:text-[#2E4F3B] font-semibold text-sm px-3 py-3 underline underline-offset-4"
              >
                Vai alla pagina Trasparenza
              </Link>
            </div>
          </div>
        </div>
      </section>

      <SullaStampa />

      <AreasOfAction />
    </Layout>
  );
}
